import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { UserService } from "src/app/core/auth";
import { PartnersService } from "src/app/partner/global/partners.service";

export const HasPartnersGuard: CanActivateFn = async (): Promise<
  boolean | UrlTree
> => {
  const router = inject(Router);
  const partners = inject(PartnersService);
  const user = inject(UserService);

  await user.isLoaded;
  if (await partners.load()) {
    return true;
  } else {
    return router.parseUrl("/account-pending");
  }
};
